import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 3, 2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  title: {
    marginBottom: theme.spacing(0.5),
    color: '#172024',
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
  blockTimeButton: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  list: {
    borderTop: '1px solid #E0E0E0',
  },
  loading: {
    margin: theme.spacing(3),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    cursor: 'pointer',
    borderBottom: '1px solid #E0E0E0',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.02)',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
    '&$rowPast': {
      '& $startTime': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $endTime': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $name': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $description': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $durationText': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $durationIcon': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '& $chevron': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(1.5),
    },
  },
  rowPast: {},
  timeColumn: {
    flex: '0 0 88px',
    minWidth: 88,
  },
  dateLabel: {
    fontSize: '0.75rem',
    lineHeight: 1.3,
    fontWeight: 600,
    color: '#172024',
    marginBottom: 2,
  },
  startTime: {
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: 1.3,
    color: '#172024',
  },
  endTime: {
    fontSize: '0.8125rem',
    lineHeight: 1.3,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  accentBar: {
    flex: '0 0 4px',
    alignSelf: 'stretch',
    borderRadius: 4,
    minHeight: 48,
  },
  detailsColumn: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.75),
  },
  name: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#172024',
  },
  upNextBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: 4,
    color: '#FFFFFF',
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    lineHeight: 1.4,
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  categoryBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 10px',
    borderRadius: 999,
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  description: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  trailingColumn: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flexShrink: 0,
    marginLeft: 'auto',
  },
  duration: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  durationIcon: {
    fontSize: 16,
    color: theme.palette.text.secondary,
  },
  durationText: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  chevron: {
    fontSize: 20,
    color: 'rgba(0, 0, 0, 0.38)',
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 3),
    borderTop: '1px solid #E0E0E0',
  },
  footerButton: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.5),
      '& .MuiSvgIcon-root': {
        fontSize: 18,
      },
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  emptyList: {
    padding: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '12px',
    lineHeight: '18px',
    borderTop: '1px solid #E0E0E0',
  },
}))

export default useStyles
